import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'HackerText',
  props: {
    text: null,
    delay: null
  },
  setup(__props: any) {

const props = __props as {
  text: string
  delay?: number
};

const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'



const element = ref()
const currentText = ref('')
const interval = ref()
const isVisible = ref(false)
const observer = ref<IntersectionObserver>()

onMounted(() => {
  observer.value = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      isVisible.value = entry.isIntersecting
    })
  })

  observer.value.observe(element.value)
})

watch(isVisible, (value) => {
  if (value) {
    if (props.delay) {
      setTimeout(animate, props.delay)
    } else {
      animate()
    }
  } else {
    currentText.value = ''
  }
})

function animate() {
  let iteration = 0
  clearInterval(interval.value)

  interval.value = setInterval(() => {
    currentText.value = props.text
      .split('')
      .map((letter, index) => {
        if (index < iteration) {
          return props.text[index]
        }

        return letters[Math.floor(Math.random() * 26)]
      })
      .join('')

    if (iteration >= props.text.length) {
      clearInterval(interval.value)
      if (observer.value) observer.value.unobserve(element.value) // Do not animate again
    }

    iteration += 1 / 3
  }, 30)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "element",
    ref: element
  }, _toDisplayString(currentText.value), 513 /* TEXT, NEED_PATCH */))
}
}

})